import React, { useEffect, useState } from "react";
import Pagination from "../../components/Pagination";
import { AiFillEye } from "react-icons/ai";
import { useHistory } from "react-router-dom";
import Spinner from "../../components/Spinner";
import { BiFilter } from "react-icons/bi";
import noharvest from "../../assets/noharvest.png";

import { GrPowerReset } from "react-icons/gr";
import moment from "moment";

const Index = () => {
  const history = useHistory();
  const [harvests, setHarvests] = useState([
    {
      id: 1,
      receiver: "John Doe",
      commodity: "Oil Palm",
      weight: "1000 tons",
      response: "8/21",
      date: new Date(),
    },
    {
      id: 1,
      receiver: "John Doe",
      commodity: "Oil Palm",
      weight: "1000 tons",
      response: "8/21",
      date: new Date(),
    },
    {
      id: 1,
      receiver: "John Doe",
      commodity: "Oil Palm",
      weight: "1000 tons",
      response: "8/21",
      date: new Date(),
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const totalPages = Math.ceil(harvests.length / itemsPerPage);
  const paginatedHarvests = harvests.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const getAllHarvestRequest = () => {
    let token = localStorage.getItem("token");
    // This is currently using mock data in state harvests, but I'll add logic to calculate pages
  };

  useEffect(() => {
    getAllHarvestRequest();
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRowClick = (row) => {
    history.push("/admin/harvest-request-detail", { state: row });
  };

  return (
    <>
      <div className="w-full lg:px-6 px-2 h-full py-10">
        <div className="w-full">
          <div className="flex items-center mb-1">
            <p className="font-bold text-base">FIlter: </p>
            <BiFilter size={30} />
          </div>
          <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-2">
            <div className="lg:mb-0 mb-2">
              <SearchFilter />
            </div>
            <Filter />
          </div>
          {harvests?.length < 1 ? (
            <EmptyHarvest />
          ) : (
            <div className="my-5">
              {loading ? (
                <div className="h-96 grid items-center justify-center">
                  <Spinner />
                </div>
              ) : (
                <div className="overflow-x-auto relative shadow-md sm:rounded-lg">
                      <table className="w-full text-xs text-center bg-white">
                        <thead className="text-xs  text-gray-700 capitalize bg-white">
                      <tr>
                            <th scope="col" className="py-3 px-3">
                          ID
                        </th>
                            <th scope="col" className="py-3 px-3">
                          to
                        </th>
                            <th scope="col" className="py-3 px-3">
                          commodity
                        </th>
                            <th scope="col" className="py-3 px-3">
                          weight requested
                        </th>
                            <th scope="col" className="py-3 px-3">
                          responses
                        </th>
                            <th scope="col" className="py-3 px-3">
                          requested date
                        </th>
                            <th scope="col" className="py-3 px-3">
                          actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedHarvests &&
                        paginatedHarvests?.map((data, index) => (
                          <tr
                            key={index}
                            className={`${
                              index % 2 === 0
                                ? "bg-white border-b dark:border-gray-200"
                                : "bg-slate-100 border-b"
                              } hover:bg-gray-100 dark:hover:bg-secondaryDark capitalize`}
                          >
                            <th
                              scope="row"
                              className="py-4 px-3 font-medium text-gray-900 whitespace-nowrap"
                            >
                              {data.id}
                            </th>
                            <td className="py-4 px-3">{data?.receiver}</td>
                            <td className="py-4 px-3">{data?.commodity}</td>
                            <td className="py-4 px-3">{data?.weight}</td>

                            <td className="py-4 px-3">{data?.response}</td>

                            <td className="py-4 px-3">
                              {moment(data?.date).format("MMM Do YY")}
                            </td>

                            <td className="py-4 px-3">
                              <div className="flex items-center gap-4 justify-center">
                                <button onClick={() => handleRowClick(data)}>
                                  <AiFillEye size={15} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
          {harvests?.length > 1 && (
            <div className="mt-5">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const SearchFilter = ({
  onChange,
  value,
  onClick,
  setQuery,
  searcFarmers,
  setRun,
}) => {
  return (
    <div className="bg-slate-200 p-4 rounded-md shadow-sm flex space-x-2 items-center w-full">
      <div className="lg:flex md:flex lg:items-center gap-3 flex-col lg:flex-row w-full">
        <div className="mb-2 lg:mb-0 md:mb-0 w-full lg:w-[300px] ">
          <input
            type={"text"}
            placeholder="Search by name, commodity, weight..."
            value={value}
            onChange={(e) => setQuery(e.target.value)}
            className="text-slate-500 bg-white p-1 rounded-md w-full "
          />
        </div>
        <div className="mb-2 lg:mb-0 md:mb-0 w-full lg:w-40   ">
          <button
            onClick={() => searcFarmers()}
            className="text-base capitalize font-semibold bg-yellowcolor w-full p-1 rounded-md "
          >
            search
          </button>
        </div>
      </div>
      <div>
        <GrPowerReset
          className="cursor-pointer"
          onClick={() => {
            setQuery("");
            setRun("run");
          }}
          size={20}
        />
      </div>
    </div>
  );
};

const Filter = ({
  regions,
  district,
  community,
  getCommunity,
  getDistrict,
  handleChange,
  filterharvest,
  setRun,
}) => {
  return (
    <div className="bg-slate-200 p-4 rounded-md shadow-sm flex space-x-2 items-center w-full">
      <div className="lg:flex md:flex items-center gap-3 flex-col lg:flex-row w-full ">
        <div className="mb-2 lg:mb-0 md:mb-0 w-full  ">
          <select
            name="region"
            onChange={handleChange}
            onInput={(e) => getDistrict(e.target.value)}
            className="w-full rounded-md border-2 text-slate-400 border-slate-400 p-1 outline-none"
          >
            {regions?.map((item, index) => {
              return (
                <option key={index} value={item}>
                  {item}
                </option>
              );
            })}
          </select>
        </div>
        <div className="mb-2 lg:mb-0 md:mb-0 w-full  ">
          <select
            name="district"
            onChange={handleChange}
            onInput={(e) => getCommunity(e.target.value)}
            className="w-full rounded-md border-2 text-slate-400 border-slate-400 p-1 outline-none"
          >
            {district?.map((item, index) => {
              return (
                <option key={index} value={item.name}>
                  {item.name}
                </option>
              );
            })}
          </select>
        </div>
        <div className="mb-2 lg:mb-0 md:mb-0 w-full   ">
          <select
            name="community"
            onChange={handleChange}
            className="w-full rounded-md border-2 text-slate-400 border-slate-400 p-1 outline-none"
          >
            {community?.map((item, index) => {
              return (
                <option key={index} value={item}>
                  {item}
                </option>
              );
            })}
          </select>
        </div>
        <div className="mb-2 lg:mb-0 md:mb-0 w-full   ">
          <button
            onClick={() => filterharvest()}
            className="text-base capitalize font-semibold bg-yellowcolor w-full p-1 rounded-md "
          >
            filter
          </button>
        </div>
      </div>
      <div>
        <GrPowerReset
          className="cursor-pointer"
          onClick={() => setRun("run")}
          size={20}
        />
      </div>
    </div>
  );
};

const EmptyHarvest = () => {
  return (
    <div className="text-center h-screen grid content-center justify-center">
      <div className="h-96">
        <img src={noharvest} alt="" className="w-36" />
        <h1 className="my-10 font-bold text-lg">No record found</h1>
      </div>
    </div>
  );
};

export default Index;
